import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type UserRole = 'admin' | 'manager' | 'viewer';

interface UserRoleState {
  role: UserRole;
  setRole: (role: UserRole) => void;
  canEdit: () => boolean;
  canDelete: () => boolean;
  canView: () => boolean;
}

export const useUserRoleStore = create<UserRoleState>()(
  persist(
    (set, get) => ({
      role: 'admin', // Default role for demo - should be fetched from backend
      setRole: (role: UserRole) => set({ role }),
      canEdit: () => {
        const role = get().role;
        return role === 'admin' || role === 'manager';
      },
      canDelete: () => {
        const role = get().role;
        return role === 'admin';
      },
      canView: () => true, // All roles can view
    }),
    {
      name: 'user-role-storage',
    }
  )
);
